import { IoArrowForwardOutline } from 'react-icons/io5';
import { PFText } from './PFText';
import { ReactNode } from 'react';
import * as stylex from '@stylexjs/stylex';
import type { StyleXStyles } from '@stylexjs/stylex';
import '@/common/tokens.stylex';
import { colors } from '@/common/tokens.stylex';
import { stylexProps } from '@/util/stylexProps';
type Props = {
  variant?: 'base' | 'baseRounded' | 'nextNews' | 'invertedHover' | 'textOnly';
  asChild?: boolean;
  children: ReactNode;
  style?: StyleXStyles;
  className?: string;
  arrow?: boolean;
};
export function PFButton(props: Props) {
  const {
    variant = 'base',
    asChild,
    children,
    style,
    className,
    arrow,
    ...rest
  } = props;
  const Tag = asChild ? 'span' : 'button';
  if (variant === 'nextNews') {
    return <Tag {...rest} {...stylexProps(className, styles.nextNews, {
      "x-default-marker": "x-default-marker",
      $$css: true
    }, style)}>
        <PFText size="base" style={styles.nextNewsLabel}>
          {children}
        </PFText>
        {arrow && <IoArrowForwardOutline className="x6bodad x1m2zvou" />}
      </Tag>;
  }
  return <Tag {...rest} {...stylexProps(className, styles.base, variant !== 'textOnly' && styles.filled, variant === 'baseRounded' ? styles.roundedFull : styles.roundedXl, variant === 'invertedHover' && styles.invertedHover, variant === 'textOnly' && styles.textOnly, variant !== 'invertedHover' && variant !== 'textOnly' && styles.filledHover, style)}>
      {children} {arrow && <IoArrowForwardOutline className="xxmjlet" />}
    </Tag>;
}
const styles = {
  nextNews: {
    k1xSpc: "x78zum5",
    kOIVth: "x167g77z",
    kGNEyG: "x6s0dn4",
    $$css: true
  },
  nextNewsLabel: {
    kMwMTN: "x6bodad x1m2zvou",
    $$css: true
  },
  base: {
    kg3NbH: "xj7an9n",
    kOIVth: "x1jnr06f",
    kzqmXN: "xh8yej3",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    ksu8eU: "xng3xce",
    kmVPX3: "xc7ga6q",
    kGuDYH: "x1q7jzdg",
    k63SB2: "x1s688f",
    k9WMMc: "x2b8uid",
    kSGwAc: "xamitd3",
    k1ekBW: "x1gbuem2",
    kAMwcw: "xz4gly6",
    kIyJzY: "x1d8287x",
    k4DuVS: "xnfc8uc",
    kXkSYi: "x9rykqi",
    $$css: true
  },
  filled: {
    kMwMTN: "xxmjlet",
    kWkggS: "x571qvy",
    $$css: true
  },
  roundedFull: {
    kaIpWk: "x10hpsqq",
    $$css: true
  },
  roundedXl: {
    kaIpWk: "x4pepcl",
    $$css: true
  },
  invertedHover: {
    kDPRdz: "xp9cbwy",
    kGzVvX: "xsh3cm4",
    $$css: true
  },
  textOnly: {
    kDPRdz: "xsgz8l0",
    kc7ZrP: "xns38ul",
    $$css: true
  },
  filledHover: {
    kGzVvX: "xrt6qkv",
    kSReZ0: "xlxv5dc",
    kc7ZrP: "xx35cyf",
    $$css: true
  }
};